import { useEffect, useRef } from "react";
import { EVENT_BLE } from "../Constantes";
import useBle from "./Ble";
import { generarMuestrasCmj, generarMuestrasCop, generarMuestrasDynamo, generarMuestrasNordic } from "../Util/simulacionBle";

/**
 * Durante la grabación, si el admin activó simulación BLE, inyecta muestras
 * con el mismo contrato que el dispositivo Jumptech.
 */
export default function useSimulacionBle({ grabando, ref_grabando, tipo, duracionSimulacionSegundos, taraSegundos }) {
    const { simulacionSinDispositivo } = useBle();
    const tipoRef = useRef(tipo);
    tipoRef.current = tipo;
    const durSimRef = useRef(duracionSimulacionSegundos);
    durSimRef.current = duracionSimulacionSegundos;
    const taraRef = useRef(taraSegundos);
    taraRef.current = taraSegundos;

    useEffect(() => {
        if (!grabando || !simulacionSinDispositivo) {
            return undefined;
        }
        const esCop = tipoRef.current === "cop";
        const gen =
            esCop
                ? generarMuestrasCop
                : tipoRef.current === "dynamo"
                  ? generarMuestrasDynamo
                  : tipoRef.current === "nordic"
                    ? generarMuestrasNordic
                    : generarMuestrasCmj;
        const d = durSimRef.current;
        const opts =
            typeof d === "number" && d > 0
                ? { duracionSegundos: d, ...(esCop ? { taraSegundos: taraRef.current ?? 5 } : {}) }
                : esCop
                  ? { taraSegundos: taraRef.current ?? 5 }
                  : {};
        const buf = gen(opts);
        let i = 0;
        let intervalId;
        const timeoutId = window.setTimeout(() => {
            intervalId = window.setInterval(() => {
                if (!ref_grabando.current) return;
                if (i >= buf.length) return;
                const row = buf[i];
                i += 1;
                document.dispatchEvent(new CustomEvent(EVENT_BLE, { detail: row }));
            }, 12);
        }, 80);
        return () => {
            window.clearTimeout(timeoutId);
            if (intervalId) window.clearInterval(intervalId);
        };
    }, [grabando, simulacionSinDispositivo, tipo, duracionSimulacionSegundos, taraSegundos]);
}
